import React from 'react';
import FormikTextInput from '@/components/core/formik/FormikTextInput';
import { useTranslations } from 'next-intl';
import { MoonOneLogo, NeedHelpBlock } from '@/app/[locale]/(welcome)/_components';
import {
    ButtonsFrame,
    Frame,
    GreyTypography,
    PageWrapper2VerticalSections,
    StyledButton,
    StyledForm,
    StyledSecondaryTitle,
    Title
} from '@/app/[locale]/(welcome)/auth/_styled';
import { Field } from 'formik';
import { Link } from '@/i18n/routing';
import { HideAbove, HideBelow } from '@/components/Media';

export default function ForgotPasswordForm({ isSubmitting }) {
    const t = useTranslations();

    return (
        <PageWrapper2VerticalSections>
            <HideAbove md>
                <MoonOneLogo />
            </HideAbove>

            <StyledForm>
                <HideBelow md>
                    <Title variant='uiType' size='3xl' modifier='S'>{t('auth.forgotPasswordTitle')}</Title>
                </HideBelow>
                <HideAbove md>
                    <Title variant='uiType' size='xl' modifier='S'>{t('auth.forgotPasswordTitle')}</Title>
                </HideAbove>

                <Frame>
                    <StyledSecondaryTitle>
                        <GreyTypography variant='uiType' size='md' modifier='R'>
                            {t('auth.forgotPasswordConstraints')}
                        </GreyTypography>
                    </StyledSecondaryTitle>

                    <Field
                      component={FormikTextInput}
                      type='email'
                      name='email'
                      placeholder={t('auth.emailPlaceholder')}
                      autoComplete='email'
                      withIncreasedHorizontalPadding
                    />
                    <ButtonsFrame>
                        <StyledButton
                          type='submit'
                          variant='filled'
                          size='sm'
                          innerText={t('auth.resetPassword')}
                          disabled={isSubmitting}
                        />
                        <Link href='/auth/login'>
                            <StyledButton type='button' variant='ghost' size='sm' innerText={t('auth.backToLogin')} />
                        </Link>
                    </ButtonsFrame>
                </Frame>
            </StyledForm>

            <NeedHelpBlock />
        </PageWrapper2VerticalSections>
    );
}
